// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true /* Do not change*/,
  securedGraphQlGateway: 'https://gateway-service.us-central1.dev.supervisr.ai',
  pathToSource: 'browser',
  trackingId: 'bvowph/arc',
  auth: { domain: 'auth.dev.o8cares.com', clientId: 'dQL86o9xlN2po4KpXxwFq30FjTe4karc', audience: 'Permission API' },
  gatewayStreamingUrl: 'https://gateway-streaming.dev.o8cares.com',
};
